import { FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { capitalize } from 'lodash';
import { Dataset } from '~/api/types';
import { DEFAULT_DATASETS_PAGE_SIZE } from '~/api/v2/endpoints/dataset';
import { Table, TableProps } from '~/components/Table';
import { TableFilterOptionItem } from '~/components/Table/components/filters/types';
import { tableContainerStyles } from '~/pages/styles';
import { columns } from '.';
import { DatasetAccessTables } from '../types';

type DatasetsTableProps = Required<
  Pick<
    TableProps,
    | 'onFiltersChange'
    | 'filterOptions'
    | 'initialFiltersModel'
    | 'onSearchChange'
    | 'onLoadMore'
    | 'hasNextPage'
    | 'initialSearchText'
    | 'onSortChange'
  >
> &
  Pick<TableProps, 'sortModel'> & {
    rows: Dataset[];
    rowCount?: number;
    isFetching: boolean;
    isError: boolean;
    tableType: DatasetAccessTables;
  };

export enum DatasetFiltersType {
  STATUS = 'status',
  OU_OWNER = 'ou_owner',
  ANATOMY = 'anatomy',
  MODALITY = 'modality',
  DATA_SOURCE_CATEGORY = 'collection_source',
  DATA_SOURCE_TYPE = 'data_format',
}

export type DatasetFilters = {
  [K in DatasetFiltersType]: TableFilterOptionItem[];
};

const DatasetsTable: FC<DatasetsTableProps> = (props) => {
  const { tableType, isFetching, isError, rowCount, rows } = props;

  return (
    <Stack spacing={3} sx={tableContainerStyles}>
      <Box display="flex" gap={2} justifyContent="space-between">
        <Typography variant="bodyXl">{capitalize(tableType)}</Typography>
      </Box>
      <Table
        {...props}
        columns={columns}
        loading={isFetching}
        paginationModel={{ page: 0, pageSize: DEFAULT_DATASETS_PAGE_SIZE }}
        sortingMode="server"
        paginationMode="server"
        rowCount={rowCount || 0}
        filterMode="server"
        searchPlaceholder="Search by dataset name (ex. Meriter dataset)"
        searchWidth="325px"
        sx={{ minHeight: '600px' }}
        wrapperHeight="600px"
        hideFooter
        rows={isError ? [] : rows}
      />
    </Stack>
  );
};

export default DatasetsTable;
